import { gql } from "@apollo/client";

export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
    fleetid
  }
}
`

export const Simulator_Query = gql`
query M_Forms_Sim_list(
    $fleet: uuid
    $id: uuid
) {
    aatmsv4_simforms(order_by: {simformname: asc}, where: {clientsid:{_eq: $id}, _and: {fleetsid: {_eq: $fleet}}}) {
    simformid
    simformname
    minutes
    blankform
    studymat
    }
   }
`
export const Aircraft_Query = gql`
query M_Forms_Aircraft_list(
    $fleet: uuid
    $id: uuid
) {
    aatmsv4_aircraftforms(order_by: {aircraftformname: asc}, where:{clientsid: {_eq: $id}, _and:{fleetsid: {_eq: $fleet}}}) {
    aircraftformid
    aircraftformname
    blankform
    studymat
    }
   }
`
export const Ground_Query = gql`
query M_Forms_Ground_list(
    $fleet: uuid
    $id: uuid
) {
    aatmsv4_groundforms(order_by: {groundformname: asc}, where:{clientsid: {_eq: $id}, _and:{fleetsid: {_eq: $fleet}}}) {
   groundformid
   groundformname
    blankform
    studymat
    }
   }
`